import React from "react";
import { stats } from "../../data/site";
import { useCountUp } from "../../lib/hooks";
import Reveal from "../chrome/Reveal";

const Stat = ({ stat }) => {
  const [value, ref] = useCountUp(stat.value, { decimals: stat.decimals || 0 });
  return (
    <div className="stat" ref={ref}>
      <div className="stat__value">
        {stat.decimals ? value.toFixed(stat.decimals) : Math.round(value)}
        {stat.suffix}
      </div>
      <div className="stat__label">{stat.label}</div>
    </div>
  );
};

const Stats = () => (
  <Reveal className="stats">
    {stats.map((stat) => (
      <Stat key={stat.label} stat={stat} />
    ))}
  </Reveal>
);

export default Stats;
